import React, { FC, useMemo, useState } from "react";

import {
  Wrapper,
  MenuItem,
  Button,
  StyledLink,
  StyledInput,
  Spacer,
  InputWrapper,
} from "./styles";
import { Props } from "./types";

const DropdownMenu: FC<Props> = ({
  className,
  style,
  visible,
  elements,
  offsetTop,
  position,
  filterable = false,
  serverFilter = false,
  searchValue,
  setSearchValue,
}) => {
  const elementsInDropdown = useMemo(() => {
    if (serverFilter) {
      return elements;
    }

    return elements.filter((element) => {
      return (
        element.name
          ?.toLocaleLowerCase()
          .includes(searchValue?.toLowerCase() || "") ||
        element.content?.props
          .join("")
          .includes(searchValue?.toLowerCase() || "")
      );
    });
  }, [elements, serverFilter, searchValue]);
  return (
    <Wrapper
      className={className}
      style={style}
      top={offsetTop}
      visible={visible}
      position={position}
    >
      {filterable && (
        <InputWrapper>
          <StyledInput
            placeholder="Search..."
            type="text"
            onClick={(e) => e.stopPropagation()}
            value={searchValue}
            onChange={(e) => {
              if (setSearchValue) {
                setSearchValue(e.target.value);
              }
            }}
          />
          <Spacer />
        </InputWrapper>
      )}
      <ul>
        {elementsInDropdown.map((element, i) => {
          return (
            <MenuItem key={i}>
              {typeof element.link !== "undefined" && element.link.to ? (
                <StyledLink {...element.link} />
              ) : (
                <Button onClick={element.onClick}>
                  {element?.name?.split("###")[0]}
                </Button>
              )}
            </MenuItem>
          );
        })}
      </ul>
    </Wrapper>
  );
};

export default DropdownMenu;
